var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1818 5.81818L13.0909 0L0 5.81818V14.5455C0 22.6182 5.58545 30.1673 13.0909 32C16.4364 31.1855 19.3891 29.2364 21.6436 26.6036L17.1055 22.0655C15.7072 22.9896 14.0323 23.4018 12.3648 23.2322C10.6974 23.0625 9.13984 22.3214 7.95636 21.1345C6.59401 19.7701 5.82881 17.9208 5.82881 15.9927C5.82881 14.0646 6.59401 12.2153 7.95636 10.8509C9.32077 9.48855 11.1701 8.72336 13.0982 8.72336C15.0263 8.72336 16.8756 9.48855 18.24 10.8509C19.4239 12.0361 20.163 13.5933 20.3326 15.2599C20.5022 16.9265 20.0919 18.6006 19.1709 20L23.3891 24.2182C25.1491 21.3673 26.1818 18.0073 26.1818 14.5455V5.81818Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0909 20.3636C14.2482 20.3636 15.3581 19.9039 16.1765 19.0855C16.9948 18.2672 17.4546 17.1573 17.4546 16C17.4546 14.8427 16.9948 13.7328 16.1765 12.9144C15.3581 12.0961 14.2482 11.6364 13.0909 11.6364C11.9336 11.6364 10.8237 12.0961 10.0054 12.9144C9.18703 13.7328 8.72729 14.8427 8.72729 16C8.72729 17.1573 9.18703 18.2672 10.0054 19.0855C10.8237 19.9039 11.9336 20.3636 13.0909 20.3636V20.3636Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPolicy);
export default __webpack_public_path__ + "static/media/New Policy.9396de7c0a07b575282a64a8c7aac1e9.svg";
export { ForwardRef as ReactComponent };